import React from 'react'
import { Button, Modal } from '@/shared/ui'

export interface SimpleFeedbackModalProps {
  open: boolean
  onClose: () => void
  title: string
  description?: string
  primaryLabel?: string
}

export default function SimpleFeedbackModal({
  open,
  onClose,
  title,
  description,
  primaryLabel = 'Fechar',
}: SimpleFeedbackModalProps) {
  return (
    <Modal open={open} onOpenChange={(v) => { if (!v) onClose() }}>
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-semibold">{title}</h2>
          {description && (
            <p className="mt-1 text-sm text-foreground/70">
              {description}
            </p>
          )}
        </div>
        <div className="flex justify-end pt-2">
          <Button onClick={onClose}>{primaryLabel}</Button>
        </div>
      </div>
    </Modal>
  )
}

